<template>
    <div class="card shadow card-header-cargo">
      <div class="card-header background-MINT card-cargo">
        <div class="row justify-content-between">
          <div class="col">
            <span>صاحب بار:  
              <span v-if="cargo.avarageRateOwner == null">
                (بدون امتیاز)
              </span>
              <div style="display:inline-block;">
                <star-rating
                  :inline="true"
                  :star-size="12"
                  :border-width="2"
                  :read-only="true"
                  :show-rating="false"
                  :rating="roundNumber(cargo.avarageRateOwner)">
                </star-rating>
            </div>
            </span>
          </div>
          <div class="col-4" style="text-align: left;">
            {{ cargo.loadingDate }}
          </div>
      </div>
      </div>
      <div class="card-body pb-0">
        <div class="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded theme-search-results-item">
          <div class="theme-search-results-item-preview">
            <div class="row" data-gutter="20">
              <div class="col-md-10">
                <div class="theme-search-results-item-flight-sections">
                  <div class="theme-search-results-item-flight-section">
                    <div class="row row-no-gutter row-eq-height">
                      <div class="col-md-10">
                        <div class="theme-search-results-item-flight-section-item">
                          <div class="row">
                            <div class="col-md-3">
                              <div class="theme-search-results-item-flight-section-path">
                                <!-- <div class="theme-search-results-item-flight-section-path-fly-time">
                                  <p v-if="cargo.priceBased == 'به صورت صافی' || cargo.priceBased == 'بصورت صافی'">
                                    {{ formatPrice(cargo.suggestedPrice) }} تومان
                                  </p>
                                  <p v-if="cargo.priceBased == 'توافقی'">
                                    <strong class="title-cargo-large">توافقی</strong>
                                  </p>
                                  <p v-if="cargo.priceBased == 'به ازای هر تن'">
                                    به ازای هر تن:
                                    {{ formatPrice(cargo.suggestedPrice) }}
                                  </p>
                                </div> -->
                                <div class="col-md-6">
                                  <div class="theme-search-results-item-flight-section-path-line-start">
                                    <span class="from-to">
                                      {{ splitedListTo[0] }}
                                    </span>
                                    <!-- <div><ion-icon name="chevron-forward-outline"></ion-icon></div> -->
                                    <div class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                      {{ splitedListTo[1] }}
                                    </div>
  
                                  </div>
                                  <div class="theme-search-results-item-flight-section-path-line"><span
                                      class="arrow-line"><ion-icon name="arrow-forward-outline"></ion-icon></span></div>
                                  <div class="theme-search-results-item-flight-section-path-line-end">
                                    <span class="from-to">{{ splitedListFrom[0] }}</span>
                                    <!-- <div class="theme-search-results-item-flight-section-path-line-dot"></div> -->
                                    <div class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                      {{ splitedListFrom[1] }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 class="text-center" v-if="cargo.distanceCity != 0">{{ roundNumber(cargo.distanceCity) + ' کیلومتر ' }}</h5>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="theme-search-results-item-book">
                  <div class="theme-search-results-item-price">
                    <div class="theme-search-results-item-price">
                      
                      <p class="title-cargo-large" v-if="cargo.title !== 'بدون عنوان'">
                        {{ cargo.title }}
                      </p>
                      <hr>
                      <p>
                        <span
                          class="fw-bolder"
                          v-for="fleet in fleets"
                          :key="fleet.id">
                          {{ fleet.title }}
                        </span>
                      </p>
                      <hr>
                          <div v-if="rate != null" class="row justify-content-between">
                            <div class="col">
                              امتیاز شما
                            </div>
                            <div class="col">
                              <span data-bs-toggle="offcanvas" :data-bs-target="'#updateScore_' + cargo.id">
                                (ویرایش امتیاز)
                              </span>
                            </div>
                            <div class="col-12 mt-2" >
                              <star-rating :inline="true" :star-size="20" :read-only="true" :show-rating="false" :rating="rate"></star-rating>
                            </div>
                          </div>
                        <!-- <div class="row justify-content-between">
                          <div class="col" style="font-size: 10px;">
                            <span class="from-to">امتیاز صاحب بار: </span> {{ roundNumber(cargo.avarageRateOwner) }} از 5
                          </div>
                          <div class="col">
                            <star-rating :star-size="20" :rating="cargo.avarageRateOwner" :read-only="true" :show-rating="false"></star-rating>

                          </div>
                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-2 text-center">
        <div class="row my-2 g-1">
          <div class="col-12" v-if="cargo.deleted_at == null">

            <button v-if="loadingCall == 0" type="button" @click.prevent="getLocation()"
              class="btn background-TEAL btn-block text-light btn-block">
              <ion-icon name="call-outline" role="img" class="md hydrated" aria-label="logo dropbox"></ion-icon>
              تماس
            </button>

            <button v-else class="btn background-blue text-light btn-block" type="button" disabled="">
              <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
              درحال بارگذاری ...
            </button>

            <button style="display: none" :id="'pardakht_' + cargo.id" type="button"
              class="btn background-blue text-light btn-block" @click="offPardakht" data-bs-toggle="offcanvas"
              :data-bs-target="'#actionSheetContent_' + cargo.id">
              <ion-icon name="call-outline" role="img" class="md hydrated" aria-label="logo dropbox"></ion-icon>
              پرداخت
            </button>
            <a v-bind:href="'tel:' + cargo.mobileNumberForCoordination"
              :id="'call_' + cargo.mobileNumberForCoordination" style="display: none"></a>
          </div>
          <div class="col-12">
            <a href="#" type="button" class="btn background-blue text-light btn-block"
              data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetIconed_' + cargo.id"
              @click="offClose"><ion-icon role="img" class="md hydrated" name="location-outline"></ion-icon>
              مسیریابی </a>
            <Routing 
              :cargo="cargo.id" 
              :fromLat="cargo.originCity.latitude"
              :fromLong="cargo.originCity.longitude" 
              :toLat="cargo.destinationCity.latitude"
              :toLong="cargo.destinationCity.longitude"
              />
          </div>
          <div class="col-12" v-if="rate == null">
            <button class="btn btn-whatsapp btn-block" data-bs-toggle="offcanvas" :data-bs-target="'#storeScore_' + cargo.id">ثبت امتیاز</button>
            <!-- Form Action Sheet -->
              
            <!-- * Form Action Sheet -->
          </div>
          <OffCanvas
                :owner_id = 'cargo.user_id'
                :cargo_id = 'cargo.id'
                :rate = rate
              />
          <div class="col-12" v-if="cargo.deleted_at != null">
            <button class="btn btn-light btn-block">با مورد نظر حذف گردید</button>
          </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import axios from "axios";
  import delivery_methods from "@/delivery_methods";
  import Routing from "./Routing.vue";
  import StarRating from 'vue-star-rating'
  import OffCanvas from "@/components/Modal/OffCanvas.vue";
  // import Swal from "sweetalert2";
  export default {
    props: {
      cargo: Object,
    },
    components:{
      Routing,
      StarRating,
      OffCanvas
    },
  
    computed: {
      splitedListFrom() {
        var names = this.cargo.fromCity;
        var nameArr = names.split(",");
        return nameArr;
      },
  
      splitedListTo() {
        var names = this.cargo.toCity;
        var nameArr = names.split(",");
        return nameArr;
      }
    },
  
    data() {
      return {
        close: "close_" + this.cargo.id,
        driver_call: this.cargo.driver_call,
        cargoId: this.cargo.id,
        loadingCall : 0,
        call: "call_" + this.cargo.mobileNumberForCoordination,
        fleets: JSON.parse(this.cargo.fleets),
        rate: this.cargo.numOfRateDriver,
      };
    },
    methods: {
      formatPrice(value) {
        let val = (value / 1).toFixed(0).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      getFormattedDates(date) {
        return moment(date).format("HH:mm");
      },
      roundNumber(value) {
        let val = (Math.round(value) / 1).toFixed(0).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
  
      strippedUsername(to) {
        if (to.length > 20) {
          return to.slice(0, 20) + "...";
        }
        return to;
      },
      getLocation() {
        this.loadingCall = 1;
        axios
          .get(`${delivery_methods.BASE_URL}api/driver/checkDriverStatusForCalling/${this.cargo.mobileNumberForCoordination}/${this.cargo.id}/${window.localStorage.getItem("latitude")}/${window.localStorage.getItem("longitude")}`)
          .then((res) => {
            this.loadingCall = 0;
            // console.log(res);
            if (res.data.result == 1) {
              // this.pardakht = 1;
              window.location = document.getElementById(this.call).href;
            }
            if (res.data.result == false) {
              // console.log(window.localStorage.getItem("closeId"));
              // console.log("pardakht_" + window.localStorage.getItem("closeId"));
              document.getElementById("pardakht_" + window.localStorage.getItem("closeId")).click();
            }
            // callStatus.value = response.data;
          })
          .catch(function (error) {
            setTimeout(() => {
              this.loadingCall = 0;
            }, 5000);
            // handle error
            console.log(error);
          });
      },

    },
  };
  </script>
  
  <style scoped>
  @import "@/assets/css/custom.css";
  </style>